import AuthService from '@/general/services/AuthService';
import { ListCache } from '@/general/utils/cache';
import serviceEvents, { UserLoggedOut } from '@/shared/services/events/serviceEvents';
import { withRawResults } from '@/shared/utils/component';
import { present } from '@/shared/utils/typescript';
import MemoClient from '../client/MemoClient';
import { DossierTaskContext } from '../models/DossierTaskContext';
import Memo, { MemoData } from '../models/Memo';
import MemoTag from '../models/MemoTag';
import TaskContext from '../models/TaskContext';

class MemoService {
  private tags = new ListCache(withRawResults(MemoClient.loadTags));

  constructor() {
    serviceEvents.on(UserLoggedOut, () => this.tags.clear());
  }

  loadTags(): Promise<Array<MemoTag>> {
    return this.tags.get();
  }

  async save(data: MemoData, context: TaskContext, memo?: Memo): Promise<void> {
    const dossierId = context instanceof DossierTaskContext ? context.dossier.id : present(memo?.dossier?.id);
    if (memo) {
      await MemoClient.update(memo.id, data, dossierId);
      memo.update(data);
    } else {
      const newMemo = await MemoClient.create(data, dossierId);
      context.memos.push(newMemo);
    }
  }

  async resolve(memo: Memo, context: TaskContext): Promise<void> {
    const dossierId = present(memo.dossier?.id);
    await MemoClient.resolve(memo.id, dossierId);
    context.resolveMemo(memo, AuthService.getCurrentUser());
  }

  async remove(memo: Memo, context: TaskContext): Promise<void> {
    const dossierId = present(memo.dossier?.id);
    await MemoClient.remove(memo.id, dossierId);
    context.removeMemo(memo);
  }
}

export default new MemoService();